import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { stripHtml } from '../../../Utils/html';

/**
 * FAQ accordion.
 *
 * Two SEO-relevant changes from the original:
 *
 *  1. Fetching moved up to the Faq page. The page needs the same questions and
 *     answers to emit FAQPage structured data, and fetching them twice would
 *     have risked the markup and the JSON-LD drifting apart.
 *  2. Answers are always rendered and collapsed with CSS, instead of being
 *     mounted only while expanded. Previously the answer text existed nowhere
 *     in the HTML until a user clicked, so crawlers never saw it — and
 *     FAQPage markup whose answers aren't in the page is invalid. Google
 *     explicitly supports FAQ content hidden behind an accordion.
 *
 * Video embeds still mount only while expanded: keeping several <iframe>s in
 * the initial HTML would cost real load time for no indexing benefit.
 */
export const Accordion = ({ items = [] }) => {
    const [activeTab, setActiveTab] = useState();

    const toggleAccordion = (i) => {
        activeTab === i ? setActiveTab(null) : setActiveTab(i);
    };

    const getYoutubeEmbedUrl = (url) => {
        if (!url) return "";

        // If it's a regular YouTube watch URL
        if (url.includes("watch?v=")) {
            return url.replace("watch?v=", "embed/");
        }

        // If it's a YouTube shorts URL
        if (url.includes("youtube.com/shorts/")) {
            return url.replace("youtube.com/shorts/", "youtube.com/embed/");
        }

        return url; // fallback
    };

    return (
        <>
            {/* Accordion start */}
            {
                items.map((item, index) => {
                    const isOpen = activeTab === index;
                    return (
                        <div key={item.idFaq ?? index} className="accordion wow fadeIn" data-wow-delay="0.4s">
                            <div className={isOpen ? 'accordion-item exp' : 'accordion-item'}>
                                <div
                                    className="accordion-titel accordion-header"
                                    onClick={() => toggleAccordion(index)}
                                    role="button"
                                    tabIndex={0}
                                    aria-expanded={isOpen}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            toggleAccordion(index);
                                        }
                                    }}
                                >
                                    <h3>Q: {stripHtml(item.question).substring(0, 500)} <span><i className="fa fa-angle-down" /></span></h3>
                                </div>
                                <div>
                                    <div className="accordion-content">
                                        <p dangerouslySetInnerHTML={{ __html: item.answer || '' }}>
                                        </p>
                                        {
                                            item.referenceLink && (
                                                <p>
                                                    <b>Reference link:</b> <Link target='_blank' to={item.referenceLink}>{item.referenceLink}</Link>
                                                </p>
                                            )
                                        }
                                        {
                                            item.videoLink && isOpen && (
                                                <p>
                                                    <b>Video Link:</b><br />
                                                    <iframe
                                                        title="video"
                                                        width="560"
                                                        height="315"
                                                        src={getYoutubeEmbedUrl(item.videoLink)}
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                        allowFullScreen
                                                    ></iframe>
                                                </p>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
            {/* Accordion Ends */}
        </>
    )
}
